import { gql } from "@grandvisionhq/graphql";
const appointment = gql`
  fragment BookAppointmentByIdResult on Appointment {
    id
    status
    isReservation
    storeInfo {
      globalStoreId
    }
    appointmentType {
      name
    }
    startTime
    endTime
    invitee {
      firstName
      lastName
      phone
      email
    }
    child {
      firstName
      lastName
      dateOfBirth
    }
    preferredChannelOfCommunication
    preferredLanguage
    customerComment
    createdBy
    products {
      ... on Variant {
        sku
        displayName
        prices {
          discountedPrice {
            price {
              amount
              currencyCode
            }
          }
          originalPrice {
            amount
            currencyCode
          }
        }
        media {
          images {
            url
          }
        }
      }
    }
  }
`;
const failures = gql`
  fragment FailureMessage on AppointmentFailure {
    message
  }
`;
const BOOK_APPOINTMENT_BY_ID = gql`
  mutation BookAppointmentById($data: BookAppointmentInput!) {
    bookAppointment(data: $data) {
      appointment {
        ...BookAppointmentByIdResult
      }
      failures {
        ...FailureMessage
      }
    }
  }
  ${appointment}
  ${failures}
`;
export {
  BOOK_APPOINTMENT_BY_ID
};
//# sourceMappingURL=book-appointment-by-id.js.map
